module.exports = __webpack_public_path__ + "static/img/draw-btn-bg.b044c328.png";